export default __webpack_public_path__ + "media/color/beam-0eff59bb.svg";